/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_HeadingInputs */

const en_visa_e2_extra_heading = /** @type {(inputs: Visa_E2_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core Considerations`)
};

const pt_visa_e2_extra_heading = /** @type {(inputs: Visa_E2_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Considerações Centrais`)
};

const es_visa_e2_extra_heading = /** @type {(inputs: Visa_E2_Extra_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consideraciones Centrales`)
};

/**
* | output |
* | --- |
* | "Core Considerations" |
*
* @param {Visa_E2_Extra_HeadingInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_heading = /** @type {((inputs?: Visa_E2_Extra_HeadingInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_HeadingInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_heading(inputs)
	if (locale === "es") return es_visa_e2_extra_heading(inputs)
	return en_visa_e2_extra_heading(inputs)
});